import React, { useId } from "react";
import { FaCheckCircle, FaPhoneAlt } from "react-icons/fa"; // ✅ added icons

export default function WhyChooseOne({
  headingTagline = "Why Choose Us",
  headingTitle = (
    <>
      Trusted Travel Partner <br /> in Pune
    </>
  ),
  tabs = defaultTabs,
}) {
  const sectionId = useId();
  const first = tabs[0];

  return (
    <section
      className="why-choose-one section-space-bottom"
      aria-labelledby={`${sectionId}-title`}
      style={{
        position: "relative",
        overflow: "hidden", // ✅ fixes scrollbars
        backgroundColor: "#f9fafc",
        padding: "10px 0",
      }}
    >
      <div className="container position-relative" style={{ zIndex: 2 }}>
        {/* Header */}
        <div className="sec-title sec-title--center mb-5 text-center">
          <div
            className="sec-title__top wow fadeInUp"
            data-wow-duration="1500ms"
            data-wow-delay="150ms"
          >
            <div className="sec-title__shape" />
            <h6
              className="sec-title__tagline text-uppercase"
              style={{
                color: "#0072bc",
                letterSpacing: "2px",
                fontWeight: 600,
              }}
            >
              {headingTagline}
            </h6>
            <div className="sec-title__shape" />
          </div>
          <h3
            id={`${sectionId}-title`}
            className="sec-title__title wow fadeInUp fw-bold"
            data-wow-duration="1500ms"
            data-wow-delay="200ms"
            style={{ color: "#001f3f", fontSize: "2rem" }}
          >
            {headingTitle}
          </h3>
        </div>

        {/* Content Section */}
        <div
          className="tabs-box wow fadeInUp"
          data-wow-duration="1500ms"
          data-wow-delay="150ms"
        >
          <div className="tabs-content">
            <div
              id={`${sectionId}-${first.id}`}
              className="why-choose-one__item tab fadeInUp active-tab"
              data-wow-delay="200ms"
            >
              {/* Soft Background overlay */}
              <div
                className="why-choose-one__item__bg"
                style={{
                  backgroundImage: `url(${first.bgUrl})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "16px",
                  position: "absolute",
                  inset: 0,
                  opacity: 0.05,
                  zIndex: 1,
                }}
              />

              <div
                className="row gutter-y-40 align-items-center position-relative"
                style={{ zIndex: 2 }}
              >
                {/* Left Content */}
                <div className="col-lg-7">
                  <div className="why-choose-one__left pe-lg-4">
                    <h2
                      className="why-choose-one__title mb-3"
                      style={{
                        color: "#001f3f",
                        fontWeight: "700",
                        fontSize: "1.8rem",
                      }}
                    >
                      {first.title}
                    </h2>

                    {first.text && (
                      <p
                        className="why-choose-one__text mb-4"
                        style={{
                          color: "#555",
                          fontSize: "1.05rem",
                          lineHeight: "1.6",
                        }}
                      >
                        {first.text}
                      </p>
                    )}

                    {/* ✅ Updated points with React Icons */}
                    {Array.isArray(first.points) && first.points.length > 0 && (
                      <div
                        className="why-choose-one__list mb-4"
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(2, 1fr)",
                          gap: "10px 20px",
                        }}
                      >
                        {first.points.map((p, idx) => (
                          <div
                            key={idx}
                            className="why-choose-one__list__item"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                              color: "#333",
                              fontSize: "1rem",
                            }}
                          >
                            <FaCheckCircle color="#0072bc" size={18} />
                            <span>{p}</span>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Call to Action */}
                    {(first.ctaHref || first.ctaLabel) && (
                      <div className=" why-choose-one__btn-box mt-4">
                        <a
                          href={first.ctaHref || "#"}
                          className="why-choose-one__btn cityride-btn cityride-btn--secondary"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "10px",
                            background: "#0072bc",
                            color: "#fff",
                            padding: "14px 28px",
                            borderRadius: "8px",
                            textDecoration: "none",
                            fontWeight: "600",
                            fontSize: "1rem",
                            boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                          }}
                        >
                          <FaPhoneAlt className="ctaLabel" /> {first.ctaLabel || "Book a Taxi"}
                        </a>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Image */}
                <div className="col-lg-5 mt-5 mt-lg-0">
                  <div className="why-choose-one__thumb text-center">
                    <img
                      src={first.imageUrl}
                      alt={first.imageAlt || "Why Choose Us"}
                      style={{
                        borderRadius: "16px",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                        maxWidth: "100%",
                        height: "auto",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Shapes (non-scrolling) */}
      <div
        className="why-choose-one__shape-left"
        style={{
          position: "absolute",
          left: 0,
          bottom: 0,
          overflow: "hidden",
          zIndex: 0,
        }}
      >
        <div
          className="why-choose-one__shape-left__one"
          style={{
            width: "200px",
            height: "200px",
            borderRadius: "50%",
            background: "rgba(0,114,188,0.08)",
            position: "absolute",
            bottom: "-50px",
            left: "-50px",
          }}
        />
      </div>

      <div
        className="why-choose-one__shape-right"
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          overflow: "hidden",
          zIndex: 0,
        }}
      >
        <div
          className="why-choose-one__shape-right__one"
          style={{
            width: "180px",
            height: "180px",
            borderRadius: "50%",
            background: "rgba(0,31,63,0.1)",
            position: "absolute",
            top: "-40px",
            right: "-40px",
          }}
        />
      </div>
    </section>
  );
}

// --- Defaults updated with Amruta Travels content ---
const defaultPoints = [
  "24×7 Customer Support & On-Time Pickup",
  "Clean, Well-Maintained Buses & Tempo Travellers",
  "Experienced & Verified Drivers",
  "Transparent, Affordable Pricing (No Hidden Charges)",
  "AC / Non-AC Options For Any Group Size",
  "Local Pune & Outstation Bookings Available",
];

const defaultTabs = [
  {
    id: "amrutaOne",
    label: "Amruta Travels",
    title: "Comfortable. Reliable. Affordable.",
    text:
      "Amruta Travels provides safe, comfortable and on-time travel for weddings, corporate movements, school/college trips and outstation tours. Our well-maintained fleet and professional drivers ensure a stress-free journey every time.",
    points: defaultPoints,
    ctaHref: "tel:+918010014995",
    ctaLabel: "Call +91 8010014995",
    bgUrl: "/images/shapes/contact-bg-1-1.png",
    imageUrl: "/images/resources/why-choose-1-1.png",
    imageAlt: "Amruta Travels Fleet",
  },
];
